/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { isMobile } from './../../components/breakpoints';

import Carousel from 'react-multi-carousel';

import { ProductCard } from './components/eshop-product-card';
import { IEshopFeaturedProductsViewProps } from './eshop-featured-products';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

/**
 *
 * IEshopFeaturedProductsProps component
 * @extends {React.PureComponent<IEshopFeaturedProductsProps<IEshopFeaturedProductsData>>}
 */
class EshopFeaturedProductsView extends React.PureComponent<IEshopFeaturedProductsViewProps> {
    public state: any = {
        width: 0,
        hasMounted: false,
        showPopup: false,
        selectedMonth: '',
        activePage: 0,
        pageSize: 3
    };

    public componentDidMount(): void {
        if (!this.state.hasMounted) {
            window.addEventListener('resize', this._updateDimensions);

            this.setState({ width: window.innerWidth, hasMounted: true });
        }
    }

    public render(): JSX.Element | null {
        const { config, gridSettings } = this.props;

        if (!this.state.hasMounted) {
            return null;
        }

        const mobileMode = isMobile(this.state.width);
        // const language = this.props.context.request.locale.split('-')[0];

        const responsive = {
            superLargeDesktop: {
                breakpoint: { max: 4000, min: 992 },
                items: config.superLargeDesktopItems || 7,
                slidesToSlide: 7
            },
            desktop: {
                breakpoint: { max: 992, min: 768 },
                items: config.desktopItems || 4,
                slidesToSlide: 4
            },
            tablet: {
                breakpoint: { max: 768, min: 540 },
                items: config.tabletItems || 4,
                slidesToSlide: 4
            },
            mobile: {
                breakpoint: { max: 540, min: 0 },
                items: config.mobileItems || 2,
                slidesToSlide: 2
            }
        };

        const mockData = this.props.productList;
        const bg = config.bgImage?.src ? { backgroundImage: `url(${config.bgImage.src})` } : { backgroundImage: '' };
        const spd = config.sliderSpeed ? config.sliderSpeed * 1000 : 5000; // Convert to milliseconds.
        const showArrows = mobileMode ? false : true;
        // const localeCode = this.props.context.request.locale.split('-')[0];

        return (
            <div className='eshop-featured-products' style={bg}>
                <div className='top'>
                    <div className='title'>
                        <p>{config.title}</p>
                    </div>
                </div>
                <Carousel responsive={responsive} infinite={true} arrows={showArrows} autoPlay={true} autoPlaySpeed={spd}>
                    {mockData.map((item: SimpleProduct, index) => {
                        return (
                            <ProductCard
                                key={index}
                                recId={item.RecordId}
                                itemId={item.ItemId!}
                                name={item.Name!}
                                description={item.Description!}
                                img={item.PrimaryImageUrl!}
                                callback={this._handleCallbackPopup}
                                mobileMode={mobileMode}
                                context={this.props.context}
                                gridSettings={gridSettings}
                                product={item}
                                enablePrice={config.enablePrice}
                                eshopUrlPrefix={config.eshopUrlPrefix}
                            />
                        );
                    })}
                </Carousel>
            </div>
        );
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', this._updateDimensions);
    }

    // private _handleCallback = () => {
    //   this.setState({ showPopup: false});
    // }

    private _handleCallbackPopup = () => {
        this.setState({ showPopup: true });
    };

    private _updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    };
}

export default EshopFeaturedProductsView;
